import React from 'react';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';
import DE from './cookie-policy/DE';
import GB from './cookie-policy/GB';
import LegalPage from './resolveLegalPageComponent';
import useLegalDocument from './useLegalDocument';

export default function CookiePolicy() {
  const { company } = useSelector((store: StoreInterface) => store.initialData);

  const { generated, isPending } = useLegalDocument('cookie-policy');

  return (
    <LegalPage
      bundles={{ de: DE, gb: GB }}
      legalPack={company?.region?.legal_pack}
      generated={generated}
      isPending={isPending}
    />
  );
}
